<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />

		<page-content v-if="text" :content="text">
			<div class="text-center margin-top-30 margin-bottom-20">
				<div v-if="!isLoggedIn || (isLoggedIn && isUserAccount)" class="claim-text-line-3">
					<router-link
						:to="{ path: '/registrazione-utente?redirect_to=/request/create/1', query: { code: code } }"
						class="button button-5"
					>
						{{ $t('Navigation.RequestsCreate') }}
					</router-link>
				</div>
			</div>
		</page-content>

		<div v-if="haveInsights" class="section-types padding-top-10 padding-bottom-50">
			<section-title component-class="margin-bottom-20">
				<h2>
					{{ $t('Section.InsightsContainerSentence1') }}
				</h2>
			</section-title>

			<div class="container list">
				<div class="insights-list col-md-12 col-sm-12 col-xs-12">
					<ul>
						<li v-for="(value, key) in insights" :key="key">
							<a :href="'#' + value.id" :title="value.title">{{ value.title }}</a>
						</li>
					</ul>
				</div>
				<div class="row col-md-12 col-sm-12 col-xs-12">
					<insights-container-box v-for="(value, key) in insights" :key="key" :insight="value"></insights-container-box>
				</div>
			</div>
		</div>

		<div class="section-types padding-top-10 padding-bottom-70">
			<section-title component-class="margin-bottom-20">
				<h2>
					{{ $t('Section.StoriesContainerSentence1') }}
					<span class="fw-400">{{ $t('Section.StoriesContainerSentence2') }}</span>
				</h2>
				<p v-html="$t('Section.StoriesContainerSentence3')"></p>
				<p class="margin-top-30">
					<router-link :to="{ path: '/storie', query: { filter: code } }" class="button button-2">
						{{ $t('Link.GoToStories') }}
					</router-link>
				</p>
			</section-title>
		</div>
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import PageContent from '@/components/partials/PageContent'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'
import SectionTitle from '@/components/partials/SectionTitle'
import ServiceHelper from '@/mixins/ServiceHelper'
import InsightsContainerBox from '@/components/sections/boxes/InsightsContainerBox'

export default {
	name: 'RequestTypesDetail',
	components: {
		PageContent,
		PageTitle,
		SectionTitle,
		InsightsContainerBox,
	},
	mixins: [AccountInfo, PageInfo, ServiceHelper],
	props: {
		code: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			pageByCode: true,
			text: null,
			insights: null,
		}
	},
	computed: {
		haveInsights() {
			return this.insights && this.insights.length > 0
		},
	},
	created() {
		// Retrieve data and insights from API
		this.loadData()
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/request-types/' + this.code, {
					params: this.loadMoreParams,
				})
				.then((response) => {
					if (response.data.info) {
						this.text = response.data.info.text
						this.insights = response.data.info.insights
						this.pageHasMore = this.hasMore(response.data)
					}
				})
				.catch(() => {})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/core/types/RequestTypesDetail.vue